import React, { useState } from 'react';
import RegionSelector from '../Cards/RegionSelector';
import { updatePackage } from '../../api/userData';

const ChangingRegionModal = ({ isOpen, onClose, packageData, refreshFlows }) => {
  const [selectedRegions, setSelectedRegions] = useState(packageData?.regions || []);
  if (!isOpen) return null;
  console.log("ChangingRegionModal packageData: ", packageData);
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal medium bottom-right open" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Изменение региона</h3>
        </div>
        <div className="modal-body">
          <RegionSelector
            selectedRegions={selectedRegions}
            onRegionsChange={setSelectedRegions}
          />
        </div>
        <div className="modal-footer">
          <button 
            className="btn btn-primary-filled"
            onClick={async () => {
              // Обновляем локальные данные
              // onRegionsChange(selectedRegions);
              
              // Вызываем API
              await updatePackage(
                packageData.integration_id,
                packageData.id,
                packageData.price,
                packageData.limit,
                packageData.holiday_send,
                selectedRegions.map(r => r.id)
              );
              
              // Обновляем потоки
              refreshFlows();
              // Закрываем модальное окно
              onClose();
            }}
          >
            Отправить на модерацию
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangingRegionModal;